
const NotFoundPage = () => {
    return <div>NotFound page content.</div>;
}

export default NotFoundPage;